export default __webpack_public_path__ + "static/media/b8c8c2e3c6a69e2f82a036b5f525dce51581594395059.6bc33cf6.webp";